import React from 'react';
import styles from './GlowingDot.module.scss';

export const GlowingDot = () => {
	return (
		<div className={styles.glowingDot}>
			<div className={styles.innerGlowingDot}></div>
		</div>
	);
};
